import type { SpendStatus } from '@/types'

/** Labels and explanations for billed-spend statuses (rules: billingsAccountSpendService.js). */
export const SPEND_STATUS: Record<SpendStatus, { label: string; hint: string }> = {
  growing: {
    label: 'Growing',
    hint: 'Billed at least 10% more than in the same period last year.',
  },
  steady: { label: 'Steady', hint: 'Within 10% of the same period last year.' },
  declining: {
    label: 'Declining',
    hint: 'Billed at least 10% less than in the same period last year.',
  },
  lapsed: {
    label: 'Lapsed',
    hint: 'Billed last year, nothing so far this year. Candidates to win back.',
  },
  new: { label: 'New', hint: 'Nothing billed last year: new or returning this year.' },
}

/** 12.3 -> "+12.3%", -4 -> "−4.0%" */
export function pctLabel(pct: number): string {
  const sign = pct > 0 ? '+' : pct < 0 ? '−' : ''
  return `${sign}${Math.abs(pct).toFixed(1)}%`
}
